import React from "react";

const HappyCustomersComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default HappyCustomersComponent;
